export default [
  /* 园区管理 */
  {
    path: "/parkOverview",
    name: "园区概况",
    component: () =>
      import("../views/smartPark/parkManagement/parkOverview/index.vue"),
  },
  {
    path: "/parkDynamics",
    name: "园区动态",
    component: () =>
      import("../views/smartPark/parkManagement/parkDynamics/index.vue"),
  },
  {
    path: "/guidance",
    name: "办事指南",
    component: () =>
      import("../views/smartPark/parkManagement/guidance/index.vue"),
  },
  {
    path: "/department",
    name: "部门管理",
    component: () =>
      import("../views/smartPark/parkManagement/department/index.vue"),
  },
  {
    path: "/areaInformation",
    name: "片区信息管理",
    component: () =>
      import("../views/smartPark/parkManagement/areaInformation/index.vue"),
  },
  /* 园区管理 */

  /* 运营管理 */
  {
    path: "/mnangement",
    name: "招商管理",
    component: () =>
      import("../views/smartPark/operationsManagement/mnangement/index.vue"),
  },
  {
    path: "/personnelManagement",
    name: "人事管理",
    component: () =>
      import(
        "../views/smartPark/operationsManagement/personnelManagement/index.vue"
      ),
  },
  {
    path: "/noticeList",
    name: "通知公告",
    component: () =>
      import("../views/smartPark/operationsManagement/notice/index.vue"),
  },
  /* 运营管理 */

  /* 厂房管理 */
  {
    path: "/plantList",
    name: "厂房列表",
    component: () =>
      import("../views/smartPark/plantManagement/plantList/index.vue"),
  },
  {
    path: "/rentManagement",
    name: "房租管理",
    component: () =>
      import("../views/smartPark/plantManagement/rentManagement/index.vue"),
  },
  /* 厂房管理 */

  /* 费用管理 */
  {
    path: "/electricityManagement",
    name: "电费管理",
    component: () =>
      import(
        "../views/smartPark/expenseManagement/electricityManagement/index.vue"
      ),
  },
  {
    path: "/waterManagement",
    name: "水费管理",
    component: () =>
      import("../views/smartPark/expenseManagement/waterManagement/index.vue"),
  },
  {
    path: "/propertyfeeManagement",
    name: "物业费管理",
    component: () =>
      import(
        "../views/smartPark/expenseManagement/propertyfeeManagement/index.vue"
      ),
  },

  /* 费用管理 */
  /* 入驻企业管理 */
  {
    path: "/enterpriseList",
    name: "企业列表",
    component: () =>
      import("../views/smartPark/companyManagement/enterpriseList/index.vue"),
  },
  {
    path: "/businessManagement",
    name: "企业入驻申请审批",
    component: () =>
      import(
        "../views/smartPark/companyManagement/businessManagement/index.vue"
      ),
  },
  /* 入驻企业管理 */
  /* 产品中心 */
  {
    path: "/warehouseList",
    name: "仓库管理",
    component: () =>
      import("../views/smartPark/productCenter/warehouse/index.vue"),
  },
  {
    path: "/productList",
    name: "产品列表",
    component: () =>
      import(
        "../views/smartPark/productCenter/warehouseStorage/productList/index.vue"
      ),
  },
  {
    path: "/outAndIn",
    name: "出入库记录",
    component: () =>
      import(
        "../views/smartPark/productCenter/warehouseStorage/outAndIn/index.vue"
      ),
  },
  {
    path: "/parkOverviewContent",
    name: "园区概况",
    component: () => import("../views/parkOverview/index.vue"),
  },
];
